import "./Spring.scss";
import SpringPicture from "./Spring.png";



const Spring = () => {

    return (
        <div className="SpringSection">
            <img className={"SpringPicture"} src={SpringPicture}/>
        </div>
    );
};

export default Spring;
